import React, { useState, useMemo } from "react";
import "../../../css/Views/UpdateModal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark, faSpinner } from "@fortawesome/free-solid-svg-icons";

const LABELS = {
  stickersLarge: "Naklejki duże",
  stickersSmall: "Naklejki małe",
  patches: "Naszywki",
  businessCards: "Wizytówki",
  pinMetalClasp: "Pin (metal)",
  pinScrewBack: "Pin (wkrętka)",
  pinPlasticClasp: "Pin (plastik)",
  pinCards: "Kartoniki do pinów",
};

const CONSUMABLE_ENUM = {
  stickersLarge: 1,
  stickersSmall: 2,
  patches: 3,
  businessCards: 4,
  pinMetalClasp: 5,
  pinScrewBack: 6,
  pinPlasticClasp: 7,
  pinCards: 8,
};

const TransferConsumablesModalBulk = ({ isOpen, myRow, recipients, onClose, onSubmit }) => {
  const [form, setForm] = useState(() =>
    Object.keys(LABELS).reduce((acc, k) => ({ ...acc, [k]: "" }), {})
  );
  const [recipientId, setRecipientId] = useState("");
  const [note, setNote] = useState("");
  const [isProcessing, setIsProcessing] = useState(false);

    const transfers = useMemo(
    () =>
      Object.entries(form)
        .filter(([_, val]) => Number(val) > 0)
        .map(([key, val]) => ({
          item: CONSUMABLE_ENUM[key],
          quantity: Number(val),
          key,
        })),
    [form]
  );

  const hasInvalidValue = useMemo(() => {
    return transfers.some(({ key, quantity }) => quantity > (myRow?.[key] ?? 0));
  }, [transfers, myRow]);


  if (!isOpen) return null;

  const handleChange = (key, value) => {
    const val = value === "" ? "" : Math.max(0, Number(value));
    setForm((prev) => ({ ...prev, [key]: val }));
  };



  const isSubmitDisabled =
    !recipientId || transfers.length === 0 || hasInvalidValue || isProcessing;

const handleSubmit = async () => {
  if (isSubmitDisabled) return;
  setIsProcessing(true);

  try {
    await onSubmit({
      recipientId: Number(recipientId),
      transfers,
      note,
      onDone: (success) => {
        if (success) onClose();
        setIsProcessing(false);
      },
    });
  } catch (err) {
    console.error(err);
    setIsProcessing(false);
  }
};


  return (
    <div className="modal-backdrop">
      <div className="modal-card">
        <div className="gear-modal-header">
          <div>Przekaż zasoby</div>
        </div>
                  <div style={{marginTop: '10px'}}>
            Odbiorca: &nbsp;
            <select
              value={recipientId}
              onChange={(e) => setRecipientId(e.target.value)}
              disabled={isProcessing}
            >
              <option value="">— wybierz osobę —</option>
              {recipients.map((r) => (
                <option key={r.userId} value={r.userId}>
                  {r.preferredName ?? `Użytkownik #${r.userId}`}
                </option>
              ))}
            </select>
          </div>
        <div className="modal-body">

          {Object.entries(LABELS).map(([key, label]) => {
            const max = myRow?.[key] ?? 0;
            const val = Number(form[key]) || 0;
            const tooMuch = val > max;
            return (
              <label key={key} className={tooMuch ? "invalid" : ""}>
                {label} ({max})
                <input
                  type="number"
                  min={0}
                  max={max}
                  value={form[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  disabled={isProcessing}
                />
                {tooMuch && <div className="error-msg">Brak tylu zasobów!</div>}
              </label>
            );
          })}

          <label className="full-width">
            Notatka
            <textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={isProcessing}
            />
          </label>
        </div>

        <div className="modal-actions">
          <div className="btn" onClick={onClose} disabled={isProcessing}>
            Anuluj
          </div>
          <button
            className="btn primary"
            onClick={handleSubmit}
            disabled={isSubmitDisabled}
          >
              { isProcessing ? <><FontAwesomeIcon icon={faSpinner} spin /> Przekazywanie ... </> : "Przekaż"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransferConsumablesModalBulk;
